import { configureStore } from '@reduxjs/toolkit';
import map3UISlice from './map3UISlice';
import map3DataReducer from './map3DataSlice';
import map3PendingReducer from './map3PendingSlice';
import admin1Reducer from './admin1Slice';

export const store = configureStore({
  reducer: {
    map3UI: map3UISlice,
    map3Data: map3DataReducer,
    map3Pending: map3PendingReducer,
    admin1: admin1Reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
